import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Memo, EAA_Add_Btn } from '~/components/EditAndAddItem';
import Actions_Wind from '~/Actions_Wind';
import Actions_Wind_V2 from '~/Actions_Wind_V2';

const styles = (theme) => ({
    formControl: {
        width: '100%',
    },
    addBtn: {
        margin: 20,
        width: 100,
    },
    itemContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    }
});

const DailyReportGenerator = (props) => {
    const { t, classes, projectList, currentDate, title, isOpen, onBack } = props;
    const titleWidth = 110;
    const titleText = title || `每日進度報表查詢: ${currentDate}`;
    const defaultOpen = isOpen || true;

    const [selectedItem, setSelectedItem] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [availableItems, setAvailableItems] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [fileUrlMoea, setFileUrlMoea] = useState('');
    const [fileUrlBoe, setFileUrlBoe] = useState('');

    const history = useHistory();

    useEffect(() => {
        const sortedProjects = [...projectList].sort((a, b) => a.order_num - b.order_num);
        console.log('projectList', sortedProjects);

        setAvailableItems(sortedProjects);
    }, []);

    const handleAddItem = () => {
        const { value: itemID, name: itemName } = selectedItem;
        const updatedSelectedItems = [...selectedItems, selectedItem];
        const updatedAvailableItems = availableItems.filter((availableItem) => availableItem !== selectedItem);

        setSelectedItems(updatedSelectedItems);
        setAvailableItems(updatedAvailableItems);
        setSelectedItem('');
    };

    const handleDeleteItem = (item) => {
        const updatedSelectedItems = selectedItems.filter((selectedItem) => selectedItem.value !== item.value);
        const updatedAvailableItems = [...availableItems, item];
        const sortedAvailableItems = [...updatedAvailableItems].sort((a, b) => a.order_num - b.order_num);
        setSelectedItems(updatedSelectedItems);
        setAvailableItems(sortedAvailableItems);
    };

    const handleSearch = () => {
        let body = {
            query_date: currentDate,
            type: "moea",
            windcontract_ids: selectedItems.map(item => item.value),
        };

        Actions_Wind_V2.getMultipleWindExcel({ ...body, type: 'moea' }).then(r => {
            if (r) {
                setFileUrlMoea(r);
            }
        });

        Actions_Wind_V2.getMultipleWindExcel({ ...body, type: 'boe' }).then(r => {
            if (r) {
                setFileUrlBoe(r);
            }
        });

        setDisabled(true);
    };

    const handleClear = () => {
        const updatedAvailableItems = [...availableItems, ...selectedItems];
        const sortedAvailableItems = [...updatedAvailableItems].sort((a, b) => a.order_num - b.order_num);
        
        setSelectedItems([]);
        setAvailableItems(sortedAvailableItems);
        setDisabled(false);
        setFileUrlBoe('');
        setFileUrlMoea('');
    };

    const handleReturn = () => {
        onBack();
    };

    const handleDownload = (type) => {
        const fileUrl = (type == 'boe')? fileUrlBoe : fileUrlMoea;

        const downloadLink = document.createElement('a');
        downloadLink.href = fileUrl;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <>
            <SearchBar style={{ marginTop: 8 }} text={titleText} defaultOpen>
                <EAA_Row>
                    {/* <Button variant="outlined" color="primary" onClick={handleReturn}>
                        {'返回'}
                    </Button> */}
                    <IconButton size="small" onClick={handleReturn}>
                        <ArrowBackIosIcon /> {'返回日期選單'}
                    </IconButton>
                </EAA_Row>
                <EAA_Row>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <EAA_TitleText width={titleWidth} text='風場' bol={true} />

                            <FormControl className={classes.formControl}>
                                <Select
                                    style={{
                                        borderRadius: 14,
                                        width: '100%',
                                        height: 46,
                                        backgroundColor: 'white',
                                        textAlign: 'start',
                                        paddingLeft: 12,
                                        border: '1px solid black',
                                        color: disabled ? '#B8B8B8' : 'black',
                                        cursor: 'pointer',
                                    }}
                                    disableUnderline
                                    value={selectedItem}
                                    onChange={(e) => setSelectedItem(e.target.value)}
                                >
                                <MenuItem value="" disabled>
                                    {'請選擇風場'}
                                </MenuItem>
                                {availableItems.map((item) => (
                                    <MenuItem key={item.value} value={item}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                                </Select>
                            </FormControl>

                        </EAA_ItemContainer>
                    </EAA_Item>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <Button
                                className={classes.addBtn}
                                variant="outlined"
                                color="primary"
                                onClick={handleAddItem}
                                disabled={disabled}
                            >
                                {'新增'}
                            </Button>
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>

                <EAA_Row>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <div className={classes.itemContainer}>
                                {selectedItems.map((item, idx) => (
                                    <Chip
                                        key={item.value}
                                        label={item.name}
                                        onDelete={!disabled ? () => handleDeleteItem(item): () => {}}
                                        deleteIcon={disabled ? <DoneIcon />: undefined}
                                        color="secondary"
                                        variant="outlined"
                                    />
                                ))}
                            </div>
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>

                <EAA_Row>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            {
                                selectedItems.length > 0 &&
                                <Button
                                    className={classes.addBtn}
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleSearch}
                                    disabled={disabled}
                                >
                                    {'查詢'}
                                </Button>
                            }
                            {
                                selectedItems.length > 0 &&
                                <Button
                                    className={classes.addBtn}
                                    variant="outlined"
                                    color="default"
                                    onClick={handleClear}
                                >
                                    {'清除'}
                                </Button>
                            }
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>

                <EAA_Row>
                    {
                        disabled &&
                        <>
                            {
                                fileUrlBoe &&
                                <EAA_Btn backgroundColor='#5597B4' text='匯出日報_能源署版' onClick={() => handleDownload('boe')} />
                            }
                            {
                                fileUrlMoea &&
                                <EAA_Btn backgroundColor='#5597B4' text='匯出日報_經濟部版' onClick={() => handleDownload('moea')} style={{ marginLeft: 17 }} />
                            }
                        </>
                    }
                </EAA_Row>
            </SearchBar>
        </>
    );    
};

const mapStateToProps = state => ({
    projectList: state.data.SwitchProjectList,
});

const mapDispatchToProps = dispatch => ({
    exportPPDailyIdDetail: body => Actions_Wind.exportPPDailyIdDetail(body),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(DailyReportGenerator);
